import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSplitsListGet } from '@/entities/splits/modules/api/splits';

export const useSplitsByParcel = (parcelId: string | undefined) =>
  useFetch({
    api: () => apiSplitsListGet(parcelId ?? ''),
    keywords: queryKeys.splits.byParcel(parcelId ?? ''),
    enabled: Boolean(parcelId),
    staleTime: 30_000,
  });
